"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChannelListOrderType = exports.ChannelListSortType = exports.ChannelListType = exports.FeedType = void 0;
var FeedType;
(function (FeedType) {
  FeedType["INBOX"] = "INBOX";
  FeedType["SPAM"] = "SPAM";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
var ChannelListType;
(function (ChannelListType) {
  ChannelListType["ALL"] = "all";
  ChannelListType["VERIFIED"] = "verified";
  ChannelListType["UNVERIFIED"] = "unverified";
})(ChannelListType = exports.ChannelListType || (exports.ChannelListType = {}));
var ChannelListSortType;
(function (ChannelListSortType) {
  ChannelListSortType["SUBSCRIBER"] = "subscribers";
})(ChannelListSortType = exports.ChannelListSortType || (exports.ChannelListSortType = {}));
var ChannelListOrderType;
(function (ChannelListOrderType) {
  ChannelListOrderType["ASCENDING"] = "asc";
  ChannelListOrderType["DESCENDING"] = "desc";
})(ChannelListOrderType = exports.ChannelListOrderType || (exports.ChannelListOrderType = {}));
;
//# sourceMappingURL=PushNotificationTypes.js.map